import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';

import { useCurrentUserAccess } from '@/store/currentUser';
import { Button } from '@/ui/Button';
import { LiveEvent } from '@/pages/LiveEvent/store/liveEvent/types';
import { useLearningJourneyBreadcrumbs } from '@/store/v2/journeys/useLearningJourneyBreadcrumbs';
import { useLearningContentNavigate } from '@/features/contentInsights/hooks/useLearningContentNavigate';
import { ADMIN_ROUTE_PATH } from '@/administration/constants/adminRoutePaths';
import { slugify } from '@/utils/misc';

const ButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
  position: absolute;
  top: 0;
  right: 0;
`;

type LiveEventControlButtonsProps = Pick<LiveEvent, 'id' | 'title'>;

export const LiveEventControlButtons = ({ id, title }: LiveEventControlButtonsProps): JSX.Element | null => {
  const navigate = useNavigate();
  const location = useLocation();
  const { navigateToAdminJourneyLearningInsights } = useLearningContentNavigate();
  const { isAdmin, loading } = useCurrentUserAccess();
  const parentJourney = useLearningJourneyBreadcrumbs({
    id: Number(id),
  });

  const handleEditClick = () => {
    const slug = slugify(title);
    const from = `${location.pathname}${location.search || ''}`;
    navigate(`${ADMIN_ROUTE_PATH.CATALOG}/live-event/${id}${slug ? `/${slug}` : ''}`, { state: { from } });
  };

  const handleMarkAttendanceClick = () => {
    navigateToAdminJourneyLearningInsights(Number(parentJourney?.journeyId), `urn:collegial:${id}`);
  };

  if (!isAdmin || loading) return null;

  return (
    <ButtonsContainer>
      <Button icon={['far', 'poll']} variant="secondary" onClick={handleMarkAttendanceClick}>
        Insights
      </Button>
      <Button icon={['far', 'pen']} variant="secondary" onClick={handleEditClick}>
        Edit
      </Button>
    </ButtonsContainer>
  );
};
